<template>
  <v-row dense>
    <v-col v-for="(vehiculo, index) in vehiculos" :key="index" xs="12" sm="12" xl="3" md="4" lg="4">
      <Vehiculo :vehiculo="vehiculo" :vehiculos="vehiculos" />

    </v-col>
    <!-- <pre>{{ vehiculosMap }}</pre> -->
  </v-row>
</template>

<script>
import Vehiculo from './Vehiculo.vue';

export default {
  props: {
    vehiculos: Array
  },
  computed: {
    vehiculosMap() {
      return this.vehiculos.map(item => {
        const anio = item.anio
        const modeloFull = item.modeloFull
        const kilometros = item.km
        const puertas = item.puertas
        const transmision = item.transmision
        const combustible = item.combustible
        const motor = item.motor
        const precio = item.precio
        const patente = item.patente
        const marca = item.marca

        return {
          anio,
          modeloFull,
          puertas,
          transmision,
          motor,
          kilometros,
          precio,
          patente,
          marca,
          combustible
        }
      })
    }
  },
  components: { Vehiculo }
}
</script>
